import { render, staticRenderFns } from "./cityinfoDetail.vue?vue&type=template&id=7851fc6a&scoped=true&"
import script from "./cityinfoDetail.vue?vue&type=script&lang=js&"
export * from "./cityinfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./cityinfoDetail.vue?vue&type=style&index=0&id=7851fc6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7851fc6a",
  null
  
)

export default component.exports